import { render, staticRenderFns } from "./WyciagiKasowe.vue?vue&type=template&id=4d04edab&scoped=true&"
import script from "./WyciagiKasowe.vue?vue&type=script&lang=js&"
export * from "./WyciagiKasowe.vue?vue&type=script&lang=js&"
import style0 from "./WyciagiKasowe.vue?vue&type=style&index=0&id=4d04edab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04edab",
  null
  
)

export default component.exports